<template>
  <div>
    <div class="d-flex align-items-center" v-for="service in services" :key="service.id">
      <i v-if="service.service.type === 'elektrisch'" class="mr-2 gg-bolt" />
      <i v-if="service.service.type === 'carwash'" class="gg-drop" />
      <i v-if="display_type === 'aanname' && service.service.type === 'last_minute'" class="lm-label" />
      <i v-if="service.service.type === 'wijziging_last_minute'" class="lmw-label" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['services', 'display_type'],
}
</script>

<style scoped>
.lm-label::after{
  color: red;
  opacity: 0.6;
  padding: 2px 5px;
  border-radius: 5px;
  font-weight: bold;
  content: 'LM';
}
.lmw-label::after{
  color: red;
  opacity: 0.6;
  padding: 2px 5px;
  border-radius: 5px;
  font-weight: bold;
  content: 'LMW';
}
.gg-drop {
  color: #3498db;
    box-sizing: border-box;
    position: relative;
    display: block;
    transform: rotate(45deg) scale(var(--ggs,0.7));
    width: 16px;
    height: 16px;
    border-radius: 0 100% 100% 100%;
    box-shadow: inset 0 0 0 2px
}

.gg-bolt {
  color: #f39c12;
    box-sizing: border-box;
    position: relative;
    display: block;
    transform: scale(var(--ggs, 0.7));
    width: 6px;
    height: 21px
}
.gg-bolt::after,
.gg-bolt::before {
    content: "";
    display: block;
    box-sizing: border-box;
    position: absolute;
    width: 0;
    height: 0;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    transform: rotate(30deg)
}
.gg-bolt::before {
    border-bottom: 12px solid;
    left: 0;
    top: 0
}
.gg-bolt::after {
    border-top: 12px solid;
    right: 0;
    bottom: 0
}
</style>
